import { c as _c } from "react/compiler-runtime";
import { Bell, Briefcase, Compass, HandCoins, Settings, Store } from "lucide-react";
import type { ReactNode } from "react";
import { partner } from "@/mocks/residual";
import { cn } from "@/lib/utils";
type Tab = {
  id: string;
  label: string;
  icon: typeof Compass;
};
const tabs: Tab[] = [{
  id: "explore",
  label: "Explore",
  icon: Compass
}, {
  id: "market",
  label: "Market",
  icon: Store
}, {
  id: "portfolio",
  label: "Portfolio",
  icon: Briefcase
}, {
  id: "income",
  label: "Income",
  icon: HandCoins
}, {
  id: "settings",
  label: "Settings",
  icon: Settings
}];
export function AppShell(t0) {
  const $ = _c(18);
  const {
    active,
    onNavigate,
    children,
    notificationCount: t1
  } = t0;
  const notificationCount = t1 === undefined ? 0 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="grid size-8 place-items-center rounded-lg bg-foreground text-background font-semibold">{partner.name[0]}</div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center gap-2">{t2}<div className="leading-tight"><div className="text-sm font-semibold">{partner.name}</div><div className="text-[11px] text-muted-foreground">Powered by Residual</div></div></div>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Bell className="size-5" />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== notificationCount) {
    t5 = notificationCount > 0 && <span className="absolute -top-0.5 -right-0.5 grid h-4 min-w-4 place-items-center rounded-full bg-primary px-1 text-[10px] font-semibold text-primary-foreground">{notificationCount}</span>;
    $[3] = notificationCount;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t5) {
    t6 = <header className="sticky top-0 z-30 border-b bg-background/80 backdrop-blur"><div className="mx-auto flex w-full max-w-2xl items-center justify-between px-4 py-3">{t3}<button type="button" aria-label="Notifications" className="relative grid size-9 place-items-center rounded-full hover:bg-muted">{t4}{t5}</button></div></header>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== children) {
    t7 = <main className="mx-auto w-full max-w-2xl flex-1 px-4 pb-28 pt-4">{children}</main>;
    $[7] = children;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== active || $[10] !== onNavigate) {
    t8 = tabs.map(t => {
      const Icon = t.icon;
      const isActive = t.id === active;
      return <button key={t.id} type="button" onClick={() => onNavigate(t.id)} className={cn("flex flex-1 flex-col items-center gap-1 py-2.5 text-[11px] transition-colors", isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground")}><Icon className={cn("size-5", isActive && "stroke-[2.4]")} /><span className={cn(isActive && "font-semibold")}>{t.label}</span></button>;
    });
    $[9] = active;
    $[10] = onNavigate;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t8) {
    t9 = <nav className="fixed inset-x-0 bottom-0 z-30 border-t bg-background/95 backdrop-blur"><div className="mx-auto flex max-w-2xl">{t8}</div></nav>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t6 || $[15] !== t7 || $[16] !== t9) {
    t10 = <div className="min-h-dvh bg-background flex flex-col">{t6}{t7}{t9}</div>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}